/*
 * @Description: 收发货人 api
 * @Author: sunxiaodong
 * @Date: 2020-08-11 17:06:26
 * @LastEditors: lidan
 * @LastEditTime: 2021-03-31 19:32:28
 */
import http from "e6-base-core/axios/config";
import { e6ModuleBaseDataApi } from "@/config/api";
const {
  host = "",
  E6_MS_TMS_E6YUN_BASE_WEB = "",
  E6_MS_TMS_BASE_WEB = ""
} = e6ModuleBaseDataApi;

//********************* 收/发货人管理 ****************** */

//获取下拉框区域名称
export function getAreaLablePosition(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/electronic/getAreaLablePositionNew`,
    method: "post",
    data
  });
}

//获取收/发货人管理列表数据
export function getPageByConditionShipperReceiver(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/shipperReceiverInfo/getPageByCondition`,
    method: "post",
    data
  });
}
//新增收/发货人信息
export function insertInfoShipperReceiver(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/shipperReceiverInfo/insertInfo`,
    method: "post",
    data
  });
}
//修改收/发货人信息
export function modifyInfoShipperReceiver(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/shipperReceiverInfo/modifyInfo`,
    method: "post",
    data
  });
}

//查询收/发货人详细信息
export function getInfoShipperReceiver(params) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/shipperReceiverInfo/getInfo`,
    method: "get",
    params
  });
}
//删除收/发货人信息
export function deleteBatchShipperReceiver(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/shipperReceiverInfo/deleteBatch`,
    method: "post",
    data
  });
}

//收发货人姓名唯一性校验
export function checkShipperReceiverName(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/shipperReceiverInfo/checkShipperReceiverName`,
    method: "post",
    data
  });
}

//收发货人手机号唯一性校验
export function checkShipperReceiverPhone(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/shipperReceiverInfo/checkShipperReceiverPhone`,
    method: "post",
    data
  });
}

//收发货人导出信息
export function exportShipperReceiver(data) {
  return http({
    headers: { "Content-Type": "application/json" },
    responseType: "blob",
    url: `${host}${E6_MS_TMS_BASE_WEB}/shipperReceiverInfo/exportShipperReceiver`,
    method: "post",
    data
  });
}

//查询收发货人历史记录列表
export function findShipperHistoryByPage(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/shipperReceiverInfo/findShipperHistoryByPage`,
    method: "post",
    data
  });
}
